import {ViewOptionsSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';
import {ProductImageTypes} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product_images.types';

export const normalizeProductImageType = (
  viewOptions: ViewOptionsSection,
): 'product' | 'model' | undefined => {
  if (viewOptions.preferredProductImageType === ProductImageTypes.BUST) {
    return 'product';
  }
  if (viewOptions.preferredProductImageType === ProductImageTypes.MODEL) {
    return 'model';
  }
  return undefined;
};
